import { Platform } from "../api/v1/api_pb";
import { grey } from "@mui/material/colors";

export const PLATFORMS = new Map([
  [
    Platform.MACOS,
    {
      label: "macOS",
      // macOS 3-core or 4-core (M1 or Intel)[1]
      //
      // [1]: https://docs.github.com/en/billing/reference/actions-runner-pricing
      githubMinuteCost: 0.062,
      githubColor: grey[700],
    },
  ],
  [
    Platform.LINUX_AMD64,
    {
      label: "Linux x86",
      // Linux 16-core[1]
      //
      // [1]: https://docs.github.com/en/billing/reference/actions-runner-pricing#x64-powered-larger-runners
      githubMinuteCost: 0.042,
      githubColor: grey[600],
    },
  ],
  [
    Platform.LINUX_ARM64,
    {
      label: "Linux arm64",
      // Linux 16-core[1]
      //
      // [1]: https://docs.github.com/en/billing/reference/actions-runner-pricing#arm64-powered-larger-runners
      githubMinuteCost: 0.026,
      githubColor: grey[500],
    },
  ],
  [
    Platform.LINUX_AMD64_GPU,
    {
      label: "Linux GPU",
      // Linux 4-core[1]
      //
      // [1]: https://docs.github.com/en/billing/reference/actions-runner-pricing#gpu-powered-larger-runners
      githubMinuteCost: 0.052,
      githubColor: grey[400],
    },
  ],
]);

export const CIRRUS_RUNNERS_MONTHLY_PRICE = 135.0;
